import { vservice } from '@niknevis/vue-modules'
import { AdminCouponApiRoute, AdminCouponRoute } from '@/modules/coupon/routes/admin-coupon.route'
import { Inertia } from '@/modules/shared/helpers/http/facades/inertia'
import { CouponRequestModel } from '@/modules/coupon/models/coupon-request.model'
import { HTTP } from '@/modules/shared/helpers/http/facades/http'

@vservice()
export class AdminCouponService {
  constructor(
    private readonly routes: AdminCouponRoute,
    private readonly apiRoutes: AdminCouponApiRoute
  ) {
  }

  storeCoupon(data: CouponRequestModel) {
    return Inertia.post(
      this.routes.store(),
      data
    )
  }

  updateCoupon(couponId: number, data: CouponRequestModel) {
    return Inertia.put(
      this.routes.update(couponId),
      data
    )
  }

  couponSearch() {
    return HTTP.get(
      this.apiRoutes.couponSearch()
    ).then(result => result.json())
  }
}

